import React from 'react';
import App from './App';
import {StateProvider} from './context/GlobalState.jsx';
import {BrowserRouter as Router} from "react-router-dom";
import {CookiesProvider} from "react-cookie";
import { hydrate, render } from "react-dom";

const APP = (<StateProvider>
    <CookiesProvider>
        <Router>
            <App/>
        </Router>
    </CookiesProvider>
</StateProvider>);

const rootElement = document.getElementById("root");
if (rootElement.hasChildNodes()) {
    hydrate(APP, rootElement);
} else {
    render(APP, rootElement);
}


/*
ReactDOM.hydrate(
    <StateProvider>
        <CookiesProvider>
            <Router>
                <App/>
            </Router>
        </CookiesProvider>
    </StateProvider>,
    document.getElementById('root')
);*/
